import styled from "styled-components";

const Container = styled.div`
  background: #ffffff;
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  width: 100%;
  padding: 12px 13px;
  min-height: 100px;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const IconContainer = styled.div``;

const LabelContainer = styled.div`
  font-size: 15px;
`;

export { Container, IconContainer, LabelContainer };
